var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gc-multiple-choice-checkbox gc-text-center gc-h-5 gc-w-5",class:[
    _vm.selected ? 'gc-bg-primary gc-text-white' : 'gc-bg-gray-300',
    _vm.singleAnswer ? 'gc-rounded-full' : 'gc-rounded' ]},[(_vm.selected)?_c('font-awesome-icon',{attrs:{"icon":_vm.faCheck}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }